import { OnlineAuthService } from './../online-store-auth/online-auth.service';
import { Inject,PLATFORM_ID,Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { Router } from '@angular/router';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { CookieService } from 'ngx-cookie';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class HttpInspectorService implements HttpInterceptor {

    constructor(
        @Inject(DOCUMENT) private document: any,
        @Inject(PLATFORM_ID) private platform: Object,
        private auth: AuthService,
        private router: Router,
        private cookieService: CookieService,
        private onlineAuth: OnlineAuthService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let online
        // if (isPlatformBrowser(this.platform)) {
        //     online = this.cookieService.get('online_store');
        // }
        // if(isPlatformServer(this.platform)){
            online = this.document.online_store;
        //}
        // console.log("cookie_value",this.document.online_store);
        // console.log("headers",req.headers)
        
        if(this.auth.authenticated && !this.checkOnline()) {
            let token =  this.auth.getToken() ? this.auth.getToken() : '';
            // console.log("if 1"+token)
            token = 'Bearer ' + token;
            const authReq = req.clone({
                headers: new HttpHeaders({Authorization: token.toString()})
            });
            return next.handle(authReq) as any;
        } else if(this.onlineAuth.authenticated && online) {
            const online_user =  this.onlineAuth.getUser();
            // console.log("if 2");
            const token = 'Bearer ' + online_user.token;
            const data = JSON.parse(online);
            const location = data.location.id ? data.location.id : '';
            const authReq = req.clone({
                headers: new HttpHeaders().set('Authorization', token.toString()).set('Location', location.toString())
            });
            return next.handle(authReq) as any;
        } else if(this.checkOnline() && online) {
            // console.log("if 3")
            const data = JSON.parse(online);
            let token =  data.store.token ? data.store.token : '';
            token = 'Bearer ' + token;
            const location = data.location.id ? data.location.id : '';
            const authReq = req.clone({
                headers: new HttpHeaders().set('Authorization', token.toString()).set('Location', location.toString())
            });
            return next.handle(authReq) as any;
        } else {
            // console.log("if 4")
            return next.handle(req) as any;
        }
        
 
    }

    checkOnline() {
        const arr = ['admin', 'partner','cash-register','customer-view'];
        for (const l of arr) {
            // if(window.location.href.includes(l)) {
            //     return false;
            // }
        }
        return true;
    }



}
